import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MaterialModule } from 'src/app/shared/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';


@NgModule({
	imports: [RouterModule, TranslateModule, BrowserAnimationsModule, PanelMenuModule, MaterialModule, DividerModule],
	declarations: [NavbarComponent],
	exports: [NavbarComponent],
})
export class NavbarModule {}
